import { mutator } from 'satcheljs';
import publicFolderTable, { PublicFolder } from '../store/publicFolderTable';
import BaseFolderType from 'owa-service/lib/contract/BaseFolderType';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import { FolderType } from 'owa-mail-favorites-store';
import { SourceWellKnownFolderType } from 'owa-folders';
import {
    addFolderToPublicFolderTable,
    addRootFolderToPublicFolderTable,
    clearPublicFolderTable,
} from '../actions/updatePublicFolderTable';

const HIDDEN_FOLDER_EXTENDED_PROPERTY_TAG = '0x10f4';
const SOURCE_WELLKNOWN_FOLDER_TYPE_PROPERTY_NAME = 'SourceWellKnownFolderType';

function getExtendedProperty(item: BaseFolderType, propertyNameOrTag?: string): any {
    if (item.ExtendedProperty) {
        for (let i = 0; i < item.ExtendedProperty.length; i++) {
            const extendedProperty = item.ExtendedProperty[i];
            if (
                extendedProperty.ExtendedFieldURI.PropertyTag === propertyNameOrTag ||
                extendedProperty.ExtendedFieldURI.PropertyName === propertyNameOrTag
            ) {
                return JSON.parse(extendedProperty.Value);
            }
        }
    }
    return undefined;
}

// fixes the FolderClass value of a Public Folder.
// see https://outlookweb.visualstudio.com/Outlook%20Web/_queries/edit/59817/
function getPublicFolderClass(item: BaseFolderType): string {
    if (!item.FolderClass) {
        // fallback to IPF.Note if FolderClass is missing
        return 'IPF.Note';
    }

    switch (item.FolderClass.toLowerCase()) {
        case 'ipf.note':
            return 'IPF.Note';
        case 'ipf.appointment':
            return 'IPF.Appointment';
        case 'ipf.contact':
            return 'IPF.Contact';
        default:
            return item.FolderClass;
    }
}

const getIsFolderHidden = (item: BaseFolderType): boolean =>
    getExtendedProperty(item, HIDDEN_FOLDER_EXTENDED_PROPERTY_TAG);
const getSourceWellKnownFolderType = (item: BaseFolderType) =>
    <SourceWellKnownFolderType>(
        parseInt(
            getExtendedProperty(item, SOURCE_WELLKNOWN_FOLDER_TYPE_PROPERTY_NAME),
            10 /* radix */
        )
    );

mutator(addFolderToPublicFolderTable, actionMessage => {
    const item: BaseFolderType = actionMessage.item;

    const folderId = item.FolderId.Id;
    const distinguishedFolderIdName = item.DistinguishedFolderId
        ? <DistinguishedFolderIdName>item.DistinguishedFolderId
        : undefined;

    const folder: PublicFolder = {
        ...{
            isExpanded: false,
            childFolderIds: [],
            distinguishedFolderId: distinguishedFolderIdName,
            UnreadCount: (<FolderType>item).UnreadCount,
            TotalCount: item.TotalCount,
            isHidden: getIsFolderHidden(item),
            sourceWellKnownFolderType: getSourceWellKnownFolderType(item),
            FolderClass: getPublicFolderClass(item),
        },
        ...item,
    };

    publicFolderTable.folderTable.set(folderId, folder);
});

mutator(addRootFolderToPublicFolderTable, actionMessage => {
    const rootFolder: PublicFolder = actionMessage.rootFolder;
    publicFolderTable.rootFolder = rootFolder;
});

mutator(clearPublicFolderTable, actionMessage => {
    publicFolderTable.folderTable.clear();
    publicFolderTable.rootFolder = null;
});
